import React, { useEffect, useState, useRef } from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface BrandFeaturedProductsProps {
  brandSlug: string;
}
export function BrandFeaturedProducts({
  brandSlug
}: BrandFeaturedProductsProps) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);
  const products = [{
    id: 1,
    name: 'Mineral 89 Hyaluronic Acid Serum',
    brand: 'Vichy',
    price: 149.99,
    originalPrice: 199.99,
    discount: 25,
    rating: 4.9,
    reviewCount: 1234,
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600',
    isBestSeller: true,
    expressDelivery: true
  }, {
    id: 2,
    name: 'Liftactiv Supreme Day Cream',
    brand: 'Vichy',
    price: 179.99,
    originalPrice: 229.99,
    discount: 22,
    rating: 4.8,
    reviewCount: 987,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=600',
    isNew: true,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Aqualia Thermal Rich Cream',
    brand: 'Vichy',
    price: 129.99,
    originalPrice: 169.99,
    discount: 24,
    rating: 4.7,
    reviewCount: 756,
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=600',
    expressDelivery: true
  }, {
    id: 4,
    name: 'Normaderm Phytosolution',
    brand: 'Vichy',
    price: 119.99,
    originalPrice: 159.99,
    discount: 25,
    rating: 4.6,
    reviewCount: 623,
    image: 'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=600',
    expressDelivery: true
  }, {
    id: 5,
    name: 'Capital Soleil UV-Age Daily SPF 50+',
    brand: 'Vichy',
    price: 139.99,
    originalPrice: 179.99,
    discount: 22,
    rating: 4.8,
    reviewCount: 891,
    image: 'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600',
    expressDelivery: true
  }, {
    id: 6,
    name: 'Dercos Anti-Dandruff Shampoo',
    brand: 'Vichy',
    price: 89.99,
    originalPrice: 119.99,
    discount: 25,
    rating: 4.7,
    reviewCount: 534,
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=600',
    expressDelivery: true
  }];
  const itemsPerView = isMobile ? 2 : isTablet ? 3 : 6;
  const totalSlides = Math.ceil(products.length / itemsPerView);
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      const slideWidth = scrollContainerRef.current.offsetWidth;
      const newSlide = Math.round(scrollLeft / slideWidth);
      setCurrentSlide(newSlide);
    }
  };
  const scrollToSlide = (index: number) => {
    if (scrollContainerRef.current) {
      const slideWidth = scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth'
      });
    }
  };
  const scrollPrev = () => {
    const newSlide = Math.max(currentSlide - 1, 0);
    scrollToSlide(newSlide);
  };
  const scrollNext = () => {
    const newSlide = Math.min(currentSlide + 1, totalSlides - 1);
    scrollToSlide(newSlide);
  };
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1352" data-mp="15df3yeemwqao">
      <div className="flex items-center gap-3 mb-6" data-id="element-1353" data-mp="15dx7zx7jg8t5">
        <div className="bg-yellow-100 p-3 rounded-lg" data-id="element-1354" data-mp="10ekkda8uexpi">
          <StarIcon className="w-6 h-6 text-yellow-600 fill-yellow-600" data-id="element-1355" data-mp="10g5i18qgewrl" />
        </div>
        <div data-id="element-1356" data-mp="1kfxc8jbfjj2m">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-1357" data-mp="1keciux0uq66c">
            Featured Products
          </h2>
          <p className="text-gray-600" data-id="element-1358" data-mp="1ofo2mlx1nx6m">Our most popular items</p>
        </div>
      </div>
      {/* Mobile/Tablet Slider */}
      {isMobile || isTablet ? <div className="relative" role="region" aria-label="Featured Products" data-id="element-1359" data-mp="1y6ip9re7cysl">
          <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3 md:gap-4" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-1360" data-mp="11ick93ddc4ds">
            {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
          width: isMobile ? 'calc(50% - 6px)' : 'calc(33.333% - 11px)'
        }} data-id="element-1361" data-mp="2lwcz0038678m">
                <EnhancedProductCard product={product} data-id="element-1362" data-mp="fb8n885porii" />
              </div>)}
          </div>
          {/* Navigation Arrows */}
          {totalSlides > 1 && <>
              <button onClick={scrollPrev} disabled={currentSlide === 0} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed z-10" aria-label="Previous products" data-id="element-1363" data-mp="5h9m9chdjds5">
                <ChevronLeftIcon className="w-6 h-6 text-gray-900" data-id="element-1364" data-mp="3iqnskw35acxb" />
              </button>
              <button onClick={scrollNext} disabled={currentSlide === totalSlides - 1} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed z-10" aria-label="Next products" data-id="element-1365" data-mp="3drum3nm9zm6n">
                <ChevronRightIcon className="w-6 h-6 text-gray-900" data-id="element-1366" data-mp="3b6mvsfb73mt2" />
              </button>
            </>}
          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-1367" data-mp="2wfe2nw833jb6">
            {Array.from({
          length: totalSlides
        }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1368" data-mp="3p764zprecywt" data-mpi={index} />)}
          </div>
        </div> /* Desktop Grid */ : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-1369" data-mp="24prq7rgcmyxp">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-1370" data-mp="28sxq8hcvbtvq" />)}
        </div>}
      <style jsx data-id="element-1371" data-mp="217c02eacbqv7">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
}